import { UserRequestExtended, CombineDisplayOption, AppUserExtended } from "../../../list-management/scripts/list-management.objects";
import { EditController } from "../../../list-management/scripts/list-management.controllers";
import { Section, SectionField } from "../../../list-management/scripts/list-management.form-sections";
import { PmUserTable, PmUserTableInfo, TableMenuItem } from "./pm-users.table";
import { TableColumnGroup } from "../../../../shared/scripts/table-column-visibility";
import { Filter, FilterTab } from "../../../list-management/scripts/list-management.filters";
import { UpdateUserRequestController, ViewUserRequestController, NewAddRequestController } from "../scripts/pm-users.controllers";
import { getDisplayDate } from "../../../../shared/scripts/date-functions";

declare var $: any;

export class ProjectManagerUsersPage {
    loadingContent: JQuery<HTMLElement>;
    loadedContent: JQuery<HTMLElement>;
    tabContainer: JQuery<HTMLElement>;
    addNewBtnContainer: JQuery<HTMLElement>;

    newUserRequestContainer: JQuery<HTMLElement>;
    currentUsersContainer: JQuery<HTMLElement>;
    userUpdatesContainer: JQuery<HTMLElement>;

    currentUsersTable: PmUserTable;
    currentUsersTableInfo: PmUserTableInfo;
    newUserRequestTable: PmUserTable;
    newUserRequestTableInfo: PmUserTableInfo;
    previousUserRequestTable: PmUserTable;
    previousUserRequestTableInfo: PmUserTableInfo;
    userUpdateTable: PmUserTable;
    userUpdateTableInfo: PmUserTableInfo;
    previousUserUpdateTable: PmUserTable;
    previousUserUpdateTableInfo: PmUserTableInfo;

    currentListController: any;
    editModalId: string;
    editController: EditController;
    updateRequestController: UpdateUserRequestController;
    viewRequestController: ViewUserRequestController;
    newUserAddController: NewAddRequestController;

    constructor() {
        $(async () => {
            // Do initialization
            this.loadingContent = $("#loading-content");
            this.loadedContent = $("#loaded-content");
            this.tabContainer = $("#pm-users-tab");
            this.addNewBtnContainer = $("#add-new-btn-container");

            this.newUserRequestContainer = $("#new-user-request-content");
            this.currentUsersContainer = $("#current-users-content");
            this.userUpdatesContainer = $("#user-updates-content");

            this.initializeTabs();

            // Edit Controller
            this.currentListController = this;
            this.editModalId = "edit-item-modal"
            this.editController = new EditController("pm-user-edit-controller", "Edit Users", "SaveUsers",
                [
                    new Section("edit-revampp-user-general", "Contact Information",
                        [
                            new SectionField("edit-user-email", "Email", "input-email", "AppUser.Email", true),
                            new SectionField("edit-user-first-name", "First Name", "input", "AppUser.FirstName", true),
                            new SectionField("edit-user-last-name", "Last Name", "input", "AppUser.LastName", true),
                            new SectionField("edit-user-organization-name", "Organization/Institution", "multi-dropdown-pl-search", "AppUser.OrganizationIds", true, "pl-organization-names"),
                        ], "", "", false
                    ),
                    new Section("edit-revampp-user-bio", "Bio Information",
                        [
                            new SectionField("edit-user-degrees", "Terminal Degrees", "multi-dropdown-pl", "AppUser.TerminalDegreeIds", false, "pl-degrees"),
                            new SectionField("edit-user-orcid-link", "ORCID Link", "input-url-orcid", "AppUser.OrcidLink", false, "", "Please enter a valid ORCID Link. It should start with 'https://orcid.org/'"),
                            new SectionField("edit-user-linkedin-link", "LinkedIn Link", "input-url-linkedin", "AppUser.LinkedinLink", false, "", "Please enter a valid LinkedIn Link. It should start with 'https://www.linkedin.com/'"),
                            new SectionField("edit-user-bio-link", "External Bio Link", "input-url", "AppUser.BioLink", false, "", "Please enter a valid URL. It should start with 'https://'"),
                        ], "", "", false
                    ),
                    new Section("edit-revampp-user-affiliations", "User Affiliations",
                        [
                            new SectionField("edit-user-affiliations", "User Affiliations", "affiliation-selection", "AppUserAffiliationList", true, "pl-member-roles", "", undefined, ["pl-center", "pl-all-cores", "pl-all-projects"])
                        ], "", "", false, true
                    ),
                    new Section("edit-revampp-user-access", "User Access",
                        [
                            new SectionField("edit-user-access", "User Access", "access-selection", "AppUserAccessList", false, "pl-access", "", undefined, ["pl-limited-center", "pl-center"])
                        ], "", "", false, true
                    ),
                ], "edit-item-modal", "AppUser.Email"
            );

            // Update User Request Controller
            this.updateRequestController = new UpdateUserRequestController("pm-user-request-controller", "Request User Update", "SendUserRequest",
                [
                    new Section("pm-update-user-group-request-section", "Update User Group Request",
                        [
                            new SectionField("request-user-groups", "User Groups/Committees", "group-selection", "AppUserGroupList", false, "pl-groups", "", undefined, ["pl-group-roles"]),
                        ], "", "", false, true
                    ),
                    new Section("pm-deactivate-user-request-section", "User Deactivation Request",
                        [
                            new SectionField("deactivate-user-section", "ReVAMPP Portal Access", "yes-no", "AppUser.IsActive", true, "", "To deactivate this user, set their Portal Access to 'No'.")
                        ], "", "", false
                    )
                ], "edit-item-modal", "AppUser.Email", "/secure/project-manager-dashboard/pm-users/pm-users"
            )
            
            // Current Users Table
            let affiliationOptions: CombineDisplayOption[] = [
                new CombineDisplayOption("RoleId", "pl-member-roles", "<br>"),
                new CombineDisplayOption("CenterId", "pl-center", ""),
                new CombineDisplayOption("CoreId", "pl-core", "", " - "),
                new CombineDisplayOption("ProjectId", "pl-project", "", " - ")
            ];

            let groupOptions: CombineDisplayOption[] = [
                new CombineDisplayOption("GroupRoleId", "pl-group-roles", " - "),
                new CombineDisplayOption("GroupId", "pl-groups", "")
            ];

            let accessOptions: CombineDisplayOption[] = [
                new CombineDisplayOption("CenterId", "pl-center", " - "),
                new CombineDisplayOption("AccessTypeId", "pl-access", "")
            ];

            this.currentUsersTableInfo = {
                tableId: "current-user-table",
                propName: "AppUser.Id",
                hasFilters: true,
                tableFilters: [
                    new FilterTab("general", "General", "General",
                        [
                            new Filter("organization-name-filter", "Organization/Institution", "multi-select-pl-multi", "AppUser.OrganizationIds", "pl-organization-names"),
                        ]
                    ),
                    new FilterTab("user-affiliations", "Affiliations", "User Affiliations",
                        [
                            new Filter("user-affiliation-role-filter", "Member Roles", "multi-select-pl-nested-single", "AppUserAffiliationList", "pl-member-roles", ["RoleId"]),
                            new Filter("user-affiliation-center-filter", "Center Affiliations", "multi-select-pl-nested-single", "AppUserAffiliationList", "pl-center", ["CenterId"]),
                            new Filter("user-affiliation-core-filter", "Core Affiliations", "multi-select-nested-combined", "AppUserAffiliationList", "pl-core", ["CoreId", "CenterId"], ["pl-center"]),
                            new Filter("user-affiliation-project-filter", "Project Affiliations", "multi-select-nested-combined", "AppUserAffiliationList", "pl-project", ["ProjectId", "CenterId"], ["pl-center"]),
                        ]
                    ),
                    new FilterTab("user-groups", "Groups", "User Groups",
                        [
                            new Filter("user-group-name-filter", "Groups/Committees", "multi-select-pl-nested-single", "AppUserGroupList", "pl-groups", ["GroupId"]),
                            new Filter("user-group-role-filter", "Group Roles", "multi-select-pl-nested-single", "AppUserGroupList", "pl-group-roles", ["GroupRoleId"]),
                            new Filter("user-access-filter", "User Access", "multi-select-pl-nested-single", "AppUserAccessList", "pl-access", ["AccessTypeId"])
                        ]
                    ),
                    new FilterTab("user-metrics", "User Metrics", "User Metrics",
                        [
                            new Filter("user-last-login-filter", "Ever Logged In", "yes-no-not-null", "AppUser.LastLoginDate"),
                            new Filter("user-has-attested-filter", "Accepted Attestation", "yes-no", "AppUser.HasAcceptedAttestation"),
                            new Filter("user-added-expertise-filter", "Added Expertise", "yes-no-not-null", "AppUser.Expertise")
                        ]
                    )
                ],
                isSearchable: true,
                hasDetailMenu: true,
                displayPropName: "AppUser.Email",
                columns: [
                    { data: "AppUser.Email", title: "Email", className: "text-left font-size12 nowrap", render: (data) => { return this.currentUsersTable.getDisplayEmail(data) } },
                    { data: "AppUser.FirstName", title: "First Name", className: "general text-left font-size12 nowrap" },
                    { data: "AppUser.LastName", title: "Last Name", className: "general text-left font-size12 nowrap" },
                    { data: "AppUser.OrganizationIds", title: "Organization/Institution", className: "general text-left font-size12 nowrap", render: (data, type) => { return this.currentUsersTable.getMultiSelectString(data, "pl-organization-names") } },
                    { data: "AppUser.OrcidLink", title: "ORCID Link", className: "user-bio font-size12 text-left nowrap" },
                    { data: "AppUser.BioLink", title: "External Bio Link", className: "user-bio font-size12 text-left nowrap" },
                    { data: "AppUser.LinkedinLink", title: "LinkedIn Link", className: "user-bio font-size12 text-left nowrap" },
                    { data: "AppUserAffiliationList", title: "ReVAMPP Affiliations", className: "user-affiliations text-left font-size12 nowrap", render: (data) => { return this.currentUsersTable.getCombinedContent(data, affiliationOptions) } },
                    { data: "AppUserGroupList", title: "Group Affiliations", className: "user-groups font-size12 text-left nowrap", render: (data, type) => { return this.currentUsersTable.getCombinedContent(data, groupOptions) } },
                    { data: "AppUserAccessList", title: "User Access", className: "user-groups font-size12 text-left nowrap", render: (data, type) => { return this.currentUsersTable.getCombinedContent(data, accessOptions) } },
                    { data: "AppUser.LastLoginDate", title: "Ever Logged In", className: "user-metrics text-center font-size12 nowrap", render: (data) => { return this.currentUsersTable.getYesNoDisplay(data) } },
                    { data: "AppUser.LastLoginDate", title: "Last Login Date", className: "user-metrics text-left font-size12 nowrap", render: (data) => { return getDisplayDate(data); } },
                    { data: "AppUser.HasAcceptedAttestation", title: "Accepted Attestation", className: "user-metrics text-center font-size12 nowrap", render: (data) => { return this.currentUsersTable.getYesNoDisplay(data) } },
                    { data: "AppUser.AttestationLastUpdated", title: "Attestation Date", className: "user-metrics text-left font-size12 nowrap", render: (data) => { return getDisplayDate(data); } },
                    { data: "AppUser.Expertise", title: "Added Expertise", className: "user-metrics text-center font-size12 nowrap", render: (data) => { return this.currentUsersTable.getYesNoDisplay(data) } },
                ],
                tableColumnGroups: [
                    new TableColumnGroup("General", true, [], "general"),
                    new TableColumnGroup("User Bio", false, [], "user-bio"),
                    new TableColumnGroup("User Affiliations", false, [], "user-affiliations"),
                    new TableColumnGroup("User Groups", false, [], "user-groups"),
                    new TableColumnGroup("User Metrics", false, [], "user-metrics")
                ],
                hasRowClick: false,
                rowClickOnClick: undefined,
                tableMenuItems: [
                    new TableMenuItem("edit-user-contact-info", "Edit Contact Information", "page.openEditModal('current-users', 'edit-revampp-user-general')"),
                    new TableMenuItem("edit-user-bio-info", "Edit Bio Information", "page.openEditModal('current-users', 'edit-revampp-user-bio')"),
                    new TableMenuItem("edit-user-affiliation", "Edit ReVAMPP Affiliations", "page.openEditModal('current-users', 'edit-revampp-user-affiliations')"),
                    new TableMenuItem("edit-user-access", "Edit User Access", "page.openEditModal('current-users', 'edit-revampp-user-access')"),
                    new TableMenuItem("request-user-update-groups", "Request User Group Update", "page.openRequestModal('current-users', 'pm-update-user-group-request-section')", "fa-solid fa-user-gear"),
                    new TableMenuItem("request-user-update-groups", "Request User Deactivation", "page.openRequestModal('current-users', 'pm-deactivate-user-request-section')", "fa-solid fa-user-gear"),
                ],
                getItemsRoute: "/secure/project-manager-dashboard/pm-users/pm-users?handler=CurrentUsers",
                tableVariableName: "currentUsersTable",
                hasFilterRule: false,
                filterRule: undefined,
                defaultOrder: [0, 'asc']
            }

            // New Users Request Table
            this.newUserRequestTableInfo = {
                tableId: "new-user-request-table",
                propName: "UserRequest.Id",
                hasFilters: false,
                tableFilters: [],
                isSearchable: true,
                hasDetailMenu: false,
                displayPropName: "UpdateUserRequest.Email",
                columns: [
                    { data: "UserRequest.StatusId", title: "Status", className: "text-center font-size12 nowrap", render: (data) => { return this.newUserRequestTable.getDisplayStatus(data) } },
                    { data: "UpdateUserRequest.Email", title: "Email", className: "text-left font-size12 nowrap" },
                    { data: "UpdateUserRequest.FirstName", title: "First Name", className: "text-left font-size12 nowrap" },
                    { data: "UpdateUserRequest.LastName", title: "Last Name", className: "text-left font-size12 nowrap" },
                    { data: "UserRequest.TypeId", title: "Request Type", className: "text-left font-size12 nowrap", render: (data) => { return this.newUserRequestTable.getPickListContent(data, "pl-request-type") } },
                    {
                        data: (row, type, val, meta) => {
                            if (type == "sort") {
                                return row.UserRequest.CreateDate;
                            }
                            else {
                                return getDisplayDate(row.UserRequest.CreateDate);
                            }
                        },
                        title: "Request Date", className: "text-left font-size12 nowrap"
                    }
                    //{ data: "UserRequest.CreateDate", title: "Request Date", className: "text-left font-size12 nowrap", render: (data) => { return getDisplayDate(data) } }
                ],
                tableColumnGroups: [],
                hasRowClick: true,
                rowClickOnClick: (requestId): void => {
                    this.newUserAddController.openModal(requestId);
                },
                tableMenuItems: [],
                getItemsRoute: "/secure/project-manager-dashboard/pm-users/pm-users?handler=UserRequests",
                tableVariableName: "newUserRequestTable",
                hasFilterRule: true,
                filterRule: (data): boolean => {
                    if (data.UserRequest.StatusId == 1) {
                        return true;
                    }
                    return false;
                },
                defaultOrder: [5, 'asc']
            }

            // Updates In Progress Table
            this.userUpdateTableInfo = {
                tableId: "in-progress-user-table",
                propName: "UserRequest.Id",
                hasFilters: false,
                tableFilters: [],
                isSearchable: true,
                hasDetailMenu: false,
                displayPropName: "UpdateUserRequest.Email",
                columns: [
                    { data: "UserRequest.StatusId", title: "Status", className: "text-center font-size12 nowrap", render: (data) => { return this.userUpdateTable.getDisplayStatus(data)} },
                    { data: "UpdateUserRequest.Email", title: "Email", className: "text-left font-size12 nowrap" },
                    { data: "UpdateUserRequest.FirstName", title: "First Name", className: "text-left font-size12 nowrap" },
                    { data: "UpdateUserRequest.LastName", title: "Last Name", className: "text-left font-size12 nowrap" },
                    { data: "UserRequest.TypeId", title: "Request Type", className: "text-left font-size12 nowrap", render: (data) => { return this.userUpdateTable.getPickListContent(data, "pl-request-type")} },
                    {
                        data: (row, type, val, meta) => {
                            if (type == "sort") {
                                return row.UserRequest.CreateDate;
                            }
                            else {
                                return getDisplayDate(row.UserRequest.CreateDate);
                            }
                        },
                        title: "Request Date", className: "text-left font-size12 nowrap"
                    }
                    //{ data: "UserRequest.CreateDate", title: "Request Date", className: "text-left font-size12 nowrap", render: (data) => { return getDisplayDate(data) } }
                ],
                tableColumnGroups: [],
                hasRowClick: true,
                rowClickOnClick: (requestId): void => {
                    this.viewRequestController.openModal(requestId);
                },
                tableMenuItems: [],
                getItemsRoute: "/secure/project-manager-dashboard/pm-users/pm-users?handler=UserRequests",
                tableVariableName: "userUpdateTable",
                hasFilterRule: true,
                filterRule: (data): boolean => {
                    if (data.UserRequest.StatusId == 2) {
                        return true;
                    }
                    return false;
                },
                defaultOrder: [5, 'asc']
            }

            // Previous User Updates Table
            this.previousUserUpdateTableInfo = {
                tableId: "previous-user-updates-table",
                propName: "UserRequest.Id",
                hasFilters: true,
                tableFilters: [
                    new FilterTab("previous-user-updates-general", "General", "previous-updates-general",
                        [
                            new Filter("previous-user-updates-status", "Request Status", "multi-select-pl-single", "UserRequest.StatusId", "pl-status-type"),
                            new Filter("previous-user-updates-type", "Request Type", "multi-select-pl-single", "UserRequest.TypeId", "pl-request-type"),
                            //new Filter("previous-user-updates-center", "Associated Center", "multi-select-pl-multi", "UserRequest.RequestCenterIds", "pl-center")
                        ]
                    )
                ],
                isSearchable: true,
                hasDetailMenu: false,
                displayPropName: "UpdateUserRequest.Email",
                columns: [
                    { data: "UserRequest.StatusId", title: "Status", className: "text-center font-size12 nowrap", render: (data) => { return this.previousUserUpdateTable.getDisplayStatus(data) } },
                    { data: "UpdateUserRequest.Email", title: "Email", className: "text-left font-size12 nowrap" },
                    { data: "UpdateUserRequest.FirstName", title: "First Name", className: "text-left font-size12 nowrap" },
                    { data: "UpdateUserRequest.LastName", title: "Last Name", className: "text-left font-size12 nowrap" },
                    { data: "UserRequest.TypeId", title: "Request Type", className: "text-left font-size12 nowrap", render: (data) => { return this.previousUserUpdateTable.getPickListContent(data, "pl-request-type") } },
                    {
                        data: (row, type, val, meta) => {
                            if (type == "sort") {
                                return row.UserRequest.LastUpdated;
                            }
                            else {
                                return getDisplayDate(row.UserRequest.LastUpdated);
                            }
                        },
                        title: "Last Updated", className: "text-left font-size12 nowrap"
                    }
                    //{ data: "UserRequest.LastUpdated", title: "Last Updated", className: "text-left font-size12 nowrap", render: (data) => { return getDisplayDate(data) } }
                ],
                tableColumnGroups: [],
                hasRowClick: true,
                rowClickOnClick: (requestId): void => {
                    this.viewRequestController.openModal(requestId);
                },
                tableMenuItems: [],
                getItemsRoute: "/secure/project-manager-dashboard/pm-users/pm-users?handler=UserRequests",
                tableVariableName: "previousUserUpdateTable",
                hasFilterRule: true,
                filterRule: (data): boolean => {
                    if (data.UserRequest.StatusId >= 3) {
                        return true;
                    }
                    return false;
                },
                defaultOrder: [5, 'desc']
            }

            this.newUserAddController = new NewAddRequestController("pm-user-review-new-request-controller", "New Account Request",
                [
                    new Section("revampp-user-general", "General Information",
                        [
                            new SectionField("add-user-email", "Email", "input-email", "AppUser.Email", true),
                            new SectionField("add-user-first-name", "First Name", "input", "AppUser.FirstName", true),
                            new SectionField("add-user-last-name", "Last Name", "input", "AppUser.LastName", true),
                            new SectionField("add-user-organization-name", "Organization/Institution", "input", "AppUser.OrganizationIds", true),
                        ]
                    ),
                    new Section("revampp-user-bio", "Bio Information",
                        [
                            new SectionField("add-user-degrees", "Terminal Degrees", "multi-dropdown-pl", "AppUser.TerminalDegreeIds", false, "pl-degrees"),
                            new SectionField("add-user-orcid-link", "ORCID Link", "input-url-orcid", "AppUser.OrcidLink", false, "", "Please enter a valid ORCID Link. It should start with 'https://orcid.org/'"),
                            new SectionField("add-user-linkedin-link", "LinkedIn Link", "input-url-linkedin", "AppUser.LinkedinLink", false, "", "Please enter a valid LinkedIn Link. It should start with 'https://www.linkedin.com/'"), 
                            new SectionField("add-user-bio-link", "External Bio Link", "input-url", "AppUser.BioLink", false, "", "Please enter a valid URL. It should start with 'https://'"),
                        ]
                    ),
                    new Section("revampp-user-affiliations", "User Affiliations",
                        [
                            new SectionField("add-user-affiliations", "User Affiliations", "affiliation-selection", "AppUserAffiliationList", true, "pl-member-roles", "", undefined, ["pl-center", "pl-all-cores", "pl-all-projects"])
                        ],
                    ),
                    new Section("revampp-user-groups", "User Groups",
                        [
                            new SectionField("add-user-groups", "User Groups/Committees", "group-selection", "AppUserGroupList", false, "pl-groups", "", undefined, ["pl-group-roles"])
                        ],
                    )
                ],
                "review-new-user-modal"
            )

            // Default to New Users Request
            await this.initializeTable("new-user-requests-tab");
            this.showLoading(false);
            setTimeout(() => this.resizeTable("new-user-requests-tab"), 100);
        });
    }

    closeAllModals() {
        $(".modal").modal('hide');
    }

    initializeTabs(): void {
        let tabs = this.tabContainer.find(".nav-link");
        tabs.on('click', async (e) => {
            if (e.currentTarget.classList.contains("active")) {
                return;
            }

            let targetId = $(e.currentTarget).prop('id');

            // Show Loading
            this.showLoading(true);

            // Get Content
            await this.initializeTable(targetId);

            // Show Content
            this.showLoading(false);

            setTimeout(() => this.resizeTable(targetId), 100);
        });
        tabs.on("shown.bs.tab", (e) => {
            let targetId = $(e.currentTarget).prop('id');
            this.resizeTable(targetId)
        });
    }

    async initializeTable(tabId: string, forceRefresh: boolean = false) {
        if (tabId == "new-user-requests-tab") {
            if (forceRefresh || !this.newUserRequestTable) {
                let request = await this.getUserRequestList();
                let userRequests: UserRequestExtended[] = request['items'];
                let pickLists = request['pickLists'];
                this.newUserAddController.updateStoredLists(userRequests, pickLists);
                this.generateSectionContent("new-user-request-content", this.newUserRequestTableInfo);
                this.newUserRequestTable = new PmUserTable(this.newUserRequestTableInfo, userRequests);
                await this.newUserRequestTable.initialize();
                this.setNewUserRequestCount(userRequests.filter(item => item.UserRequest.StatusId == 1).length);
            }
        }
        else if (tabId == "current-users-tab") {
            if (forceRefresh || !this.currentUsersTable) {
                let request = await this.getUserRequestList();
                let userRequests: UserRequestExtended[] = request['items'];
                this.generateSectionContent("current-users-content", this.currentUsersTableInfo);
                this.currentUsersTable = new PmUserTable(this.currentUsersTableInfo, userRequests);
                await this.currentUsersTable.initialize();
                this.setNewUserRequestCount(userRequests.filter(item => item.UserRequest.StatusId == 1).length);
            }
        }
        else if (tabId == "user-updates-tab") {
            if (forceRefresh || !this.userUpdateTable) {
                let request = await this.getUserRequestList();
                let userRequests: UserRequestExtended[] = request['items'];
                let pickLists = request['pickLists'];
                this.viewRequestController = new ViewUserRequestController("view-request-modal", userRequests, pickLists);
                this.generateSectionContent("user-updates-content", this.userUpdateTableInfo);
                this.userUpdateTable = new PmUserTable(this.userUpdateTableInfo);
                this.generateSectionContent("previous-user-updates-content", this.previousUserUpdateTableInfo);
                this.previousUserUpdateTable = new PmUserTable(this.previousUserUpdateTableInfo);
                await this.userUpdateTable.initialize();
                await this.previousUserUpdateTable.initialize();
                this.setNewUserRequestCount(userRequests.filter(item => item.UserRequest.StatusId == 1).length);
            }
        }
    }

    resizeTable(tabId: string): void {
        if (tabId == "new-user-requests-tab") {
            if (this.newUserRequestTable) {
                this.newUserRequestTable.resizeTable();
            }
        }
        else if (tabId == "current-users-tab") {
            if (this.currentUsersTable) {
                this.currentUsersTable.resizeTable();
            }
        }
        else if (tabId == "user-updates-tab") {
            if (this.userUpdateTable) {
                this.userUpdateTable.resizeTable();
            }       
        }
    }

    resizeCollapseTable(tabId: string): void {
        if (tabId == "user-updates-tab") {
            setTimeout(() => {
                if (this.previousUserUpdateTable) {
                    this.previousUserUpdateTable.resizeTable();
                }
            }, 250)
        }            
    }

    setNewUserRequestCount(count: number): void {
        let target = $("#new-user-request-count");
        target.text(count);
    }

    showLoading(isLoading: boolean): void {
        if (isLoading) {
            this.loadingContent.removeClass("d-none");
            this.loadedContent.addClass("d-none");
            this.addNewBtnContainer.addClass("d-none");
        }
        else {
            this.loadingContent.addClass("d-none");
            this.loadedContent.removeClass("d-none");
            this.addNewBtnContainer.removeClass("d-none");
        }
    }

    generateSectionContent(sectionId: string, tableInfo: PmUserTableInfo) {
        let targetSectionContainer = $(`#${sectionId}`);

        let filterHtml = "";
        if (tableInfo.hasFilters) {
            filterHtml = this.generateFilterTabContent(tableInfo);
        }

        let detailMenuClass = "";
        if (tableInfo.hasDetailMenu) {
            detailMenuClass = "detail-menu-table"
        }

        let tableHtml = `
            <div class="list-table-container mt-4">
                <div class="revampp-datatable">
                    <table id="${tableInfo.tableId}" class="table table-striped selectable-rows w-100 ${detailMenuClass}" style="width:100%"></table>
                </div>
            </div>
        `;

        if (tableInfo.hasDetailMenu) {
            tableHtml += `
            <div id="detail-menu-container-${tableInfo.tableId}">

            </div>
            `;
        }

        let html = `
            ${filterHtml}
            ${tableHtml}
        `;

        targetSectionContainer.empty().html(html);
    }

    generateFilterTabContent(tableInfo: PmUserTableInfo): string {
        let html = "";

        if (tableInfo.tableFilters.length == 1) {
            html = `
                <div class="col-12 px-0 text-right mb-2">
                    <button type="button" class="btn btn-sm btn-outline-secondary font-size11" onclick="page.${tableInfo.tableVariableName}.resetFilters()">Reset Filters</button>
                </div>
                <div id="list-filter-tab-container">
                    <ul class="nav nav-tabs justify-content-start border-bottom-0" id="pm-table-filter-tabs-${tableInfo.tableId}" role="tablist">
                
                    </ul>
                </div>

                <div class="tab-content pm-filters-block" id="pm-table-filter-container-${tableInfo.tableId}">
            
                </div>
            `
        }
        else {
            html = `
                <div class="col-12 px-0 text-right">
                    <button type="button" class="btn btn-sm btn-outline-secondary font-size11" onclick="page.${tableInfo.tableVariableName}.resetFilters()">Reset Filters</button>
                </div>
                <div id="list-filter-tab-container">
                    <ul class="nav nav-tabs justify-content-start border-bottom-0" id="pm-table-filter-tabs-${tableInfo.tableId}" role="tablist">
                
                    </ul>
                </div>

                <div class="tab-content pm-filters-block" id="pm-table-filter-container-${tableInfo.tableId}">
            
                </div>
            `
        }
        
        return html;
    }

    openEditModal(targetTable: string, sectionId: string) {
        this.editController.showLoading(false);
        if (targetTable == "current-users") {
            let targetItem = this.currentUsersTable.targetItem;
            if (targetItem) {
                this.editController.initialize(this.currentUsersTable.pickLists, [targetItem], sectionId);
                $(`#${this.editModalId}`).modal('show');
            }
        }
    }

    openRequestModal(targetTable: string, sectionId: string) {
        this.updateRequestController.editController.showLoading(false);
        if (targetTable == "current-users") {
            let targetItem = this.currentUsersTable.targetItem;
            if (targetItem) {
                this.updateRequestController.initialize(this.currentUsersTable.pickLists, [targetItem], sectionId);
                $(`#${this.editModalId}`).modal('show');
            }
        }
    }

    async saveEditModal() {
        // if it isn't valid, don't save
        let isValid = this.editController.validate();
        if (!isValid) {
            return;
        }
        else {
            // show saving on edit modal
            this.editController.showLoading(true);

            // saves changes to DB (returns updated items)
            let result: any[] = await this.editController.save();

            // reinitialze tab
            await this.refreshActiveTab();

            // Show Saved
            this.editController.showSaved(true);

            // hide loading/close modal
            setTimeout(() => {
                $(`#${this.editModalId}`).modal('hide');

                // Don't hide information until after modal finishes hiding
                setTimeout(() => {
                    this.editController.showLoading(false);
                    this.editController.showSaved(false);
                }, 1000)
            }, 1000)
        }
    }

    async saveRequestModal() {
        // if it isn't valid, don't save
        let isValid = this.updateRequestController.editController.validate();
        let isChanged = this.updateRequestController.validateChanged();
        if (!isValid || !isChanged) {
            return;
        }
        else {
            // show saving on edit modal
            this.updateRequestController.showLoading(true);

            // saves changes to DB (returns updated items)
            let result: any[] = await this.updateRequestController.save();

            // reinitialze tab
            await this.refreshActiveTab();

            // remove the user updates in progress table so a new will spawn
            this.userUpdateTable = undefined;

            // Show Saved
            this.updateRequestController.showSaved(true);

            // hide loading/close modal
            setTimeout(() => {
                $(`#${this.editModalId}`).modal('hide');

                // Don't hide information until after modal finishes hiding
                setTimeout(() => {
                    this.updateRequestController.showLoading(false);
                    this.updateRequestController.showSaved(false);
                }, 1000)
            }, 1000)
        }
    }

    async approveNewUserRequest() {
        let isValid = this.newUserAddController.addController.validate();
        if (!isValid) {
            return;
        }
        else {
            this.newUserAddController.showLoading(true);
            let newUser: AppUserExtended = this.newUserAddController.addController.getCurrentItem();

            let result = await this.updateRequestApprove(newUser, this.newUserAddController.currentRequest);

            await this.refreshActiveTab();

            this.newUserAddController.showSaved(true);

            // hide loading/close modal
            setTimeout(() => {
                $(`#${this.newUserAddController.modalIdTarget}`).modal('hide');

                // Don't hide information until after modal finishes hiding
                setTimeout(() => {
                    this.newUserAddController.showLoading(false);
                    this.newUserAddController.showSaved(false);
                }, 1000)
            }, 1000)
        }
    }

    async denyNewUserRequest() {
        this.newUserAddController.showLoading(true);
        let newUser: AppUserExtended = this.newUserAddController.addController.getCurrentItem();

        let result = await this.updateRequestDeny(newUser, this.newUserAddController.currentRequest);

        await this.refreshActiveTab();

        this.newUserAddController.showSaved(true);

        // hide loading/close modal
        setTimeout(() => {
            $(`#${this.newUserAddController.modalIdTarget}`).modal('hide');

            // Don't hide information until after modal finishes hiding
            setTimeout(() => {
                this.newUserAddController.showLoading(false);
                this.newUserAddController.showSaved(false);
            }, 1000)
        }, 1000);
    }


    async refreshActiveTab() {
        let activeTab = this.tabContainer.find(".active").first();
        let targetId = activeTab.prop('id');

        // Get Current Filters
        let selectedTab: string = "";
        let currentFilterOptions: any[][] = [];
        if (targetId == "current-users-tab") {
            selectedTab = this.getSelectedFilterTabId();
            currentFilterOptions = this.currentUsersTable.filterTabs.map(tab => {
                return tab.getSelectedValues();
            });
        }

        // Update Table
        await this.initializeTable(targetId, true);

        // Set Filters
        if (targetId == "current-users-tab") {
            for (let i = 0; i < currentFilterOptions.length; i++) {
                let tabVals = currentFilterOptions[i];
                this.currentUsersTable.filterTabs[i].setSelectedValues(tabVals);
            }
            $(`#${selectedTab}`).trigger("click");
        }
    }

    getSelectedFilterTabId(): string {
        let selectedTab = $("#list-filter-tab-container").find(".active").first();
        return selectedTab.prop("id");
    }

    async getUserRequestList(): Promise<any> {
        let route = `/secure/project-manager-dashboard/pm-users/pm-users?handler=UserRequests`
        let result: Promise<any>;
        try {
            result = await $.ajax({
                url: route,
                method: "GET",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
            })
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async updateRequestApprove(updatedUser: AppUserExtended, targetRequest: UserRequestExtended): Promise<any> {
        let result: Promise<any>;
        try {
            result = await $.ajax({
                url: `/secure/project-manager-dashboard/pm-users/pm-users?handler=ApproveNewUserRequest`,
                method: "POST",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(updatedUser), requestId: targetRequest.UserRequest.Id }
            })
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async updateRequestDeny(updatedUser: AppUserExtended, targetRequest: UserRequestExtended): Promise<any> {
        let result: Promise<any>;
        try {
            result = await $.ajax({
                url: `/secure/project-manager-dashboard/pm-users/pm-users?handler=DenyNewUserRequest`,
                method: "POST",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(updatedUser), requestId: targetRequest.UserRequest.Id }
            })
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    openAddNewUser(): void {
        this.newUserAddController.openModal();
    }

    async createNewUserRequest(): Promise<any> {
        let isValid = this.newUserAddController.addController.validate();
        if (!isValid) {
            return;
        }
        else {
            this.newUserAddController.hideErrorMessage();
            this.newUserAddController.showLoading(true);
            let newUser: AppUserExtended = this.newUserAddController.addController.getCurrentItem();

            let result = await this.sendNewUserRequest(newUser);

            if (result != "") {
                this.newUserAddController.showErrorMessage(result);
                this.newUserAddController.showLoading(false);
            }
            else {               
                // Ensure these tables refresh when new user is added
                this.userUpdateTable = undefined;
                this.previousUserUpdateTable = undefined;

                await this.refreshActiveTab();

                this.newUserAddController.showSaved(true);

                // hide loading/close modal
                setTimeout(() => {
                    $(`#${this.newUserAddController.modalIdTarget}`).modal('hide');

                    // Don't hide information until after modal finishes hiding
                    setTimeout(() => {
                        this.newUserAddController.showLoading(false);
                        this.newUserAddController.showSaved(false);
                    }, 1000)
                }, 1000)
            }

        }
    }

    async sendNewUserRequest(newUser: AppUserExtended): Promise<string> {
        let result: Promise<any>;
        try {
            result = await $.ajax({
                url: `/secure/project-manager-dashboard/pm-users/pm-users?handler=CreateNewUserRequest`,
                method: "POST",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(newUser) }
            })
            return result;
        }
        catch (error: any) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
            return "";
        }
    }
}